/* RJ October 2026 CRO draft (R-D10): no ring size is chosen for the customer.
   Wherever the theme's variant picker shows a "Size" option with more than one value (product page, its sticky bar,
   quick view), the size starts unselected, the label reads "Choose your size", and Add to cart is held until a size is
   picked. Single-size and non-sized products are untouched. A size already in the URL (?variant=) is respected, so
   links from a size filter keep their size. Relies on the null-safe option reading added to assets/product.js. */
(function () {
  'use strict';
  var PROMPT = 'Choose your size';
  var isSize = function (fs) {
    var n = (fs.querySelector('input') || {}).name || (fs.querySelector('select') || {}).name || '';
    return /size/i.test(n) && fs.querySelectorAll('input').length > 1;
  };
  function sizeSets(vs) { return Array.prototype.filter.call(vs.querySelectorAll('fieldset'), isSize); }
  function missing(vs) { return sizeSets(vs).some(function (fs) { return !fs.querySelector('input:checked'); }); }
  function buttonsFor(section) {
    var form = document.getElementById('product-form-' + section);
    var list = form ? Array.prototype.slice.call(form.querySelectorAll('.single-add-to-cart-button')) : [];
    Array.prototype.forEach.call(document.querySelectorAll('.mobile-sticky-atc__button'), function (b) {
      var host = b.closest('mobile-sticky-atc');
      if (host && host.dataset.targetForm === 'product-form-' + section) list.push(b);
    });
    return list;
  }
  function setLabel(btn, text) {
    var t = btn.querySelector('.single-add-to-cart-button--text');
    if (t) t.setAttribute('data-content', text);
    else if (!btn.querySelector('svg, img')) btn.textContent = text;
    else { var s = btn.querySelector('span:not([class*=loading])'); if (s) s.textContent = text; }
  }
  /* Show the waiting state: price stays visible (all sizes cost the same; if not, the price shown is the lowest size's). */
  function holdState(vs) {
    var section = vs.dataset.section;
    sizeSets(vs).forEach(function (fs) {
      fs.classList.add('rj-size-required');
      var label = fs.querySelector('.form__label__value');
      if (label && !fs.querySelector('input:checked')) label.textContent = PROMPT;
    });
    ['price-' + section, 'price-' + section + '--sticky'].forEach(function (id) {
      var p = document.getElementById(id); if (p) p.classList.remove('visibility-hidden');
    });
    buttonsFor(section).forEach(function (b) {
      if (!b.dataset.rjLabel) b.dataset.rjLabel = (b.querySelector('.single-add-to-cart-button--text') || {}).dataset ? (b.querySelector('.single-add-to-cart-button--text').dataset.content || '') : b.textContent.trim();
      b.classList.remove('sold-out');
      b.removeAttribute('disabled');
      b.setAttribute('aria-disabled', 'true');
      b.classList.add('rj-size-wait');
      setLabel(b, PROMPT);
    });
  }
  function releaseState(vs) {
    sizeSets(vs).forEach(function (fs) { fs.classList.remove('rj-size-required', 'rj-size-error'); });
    buttonsFor(vs.dataset.section).forEach(function (b) {
      if (!b.classList.contains('rj-size-wait')) return;
      b.classList.remove('rj-size-wait');
      b.removeAttribute('aria-disabled');
      if (b.dataset.rjLabel && !b.querySelector('.single-add-to-cart-button--text')) setLabel(b, b.dataset.rjLabel);
    });
  }
  function prepare(vs) {
    if (vs.__rjSize || !sizeSets(vs).length) return;
    vs.__rjSize = true;
    var urlVariant = /[?&]variant=\d+/.test(location.search) && !vs.closest('#Product-Drawer');
    if (!urlVariant) {
      sizeSets(vs).forEach(function (fs) {
        Array.prototype.forEach.call(fs.querySelectorAll('input'), function (i) { i.checked = false; });
      });
      if (typeof vs.updateOptions === 'function') { vs.updateOptions(); vs.updateMasterId(); }
    }
    if (missing(vs)) holdState(vs);
  }
  function scan(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('variant-selects, variant-radios'), prepare);
  }
  /* After the theme handles a change, restore the waiting state if a size is still missing. */
  document.addEventListener('change', function (e) {
    var vs = e.target.closest && e.target.closest('variant-selects, variant-radios');
    if (!vs || !vs.__rjSize) return;
    setTimeout(function () { if (missing(vs)) holdState(vs); else releaseState(vs); }, 0);
  });
  function block(section, e) {
    var vs = document.querySelector('variant-selects[data-section="' + section + '"], variant-radios[data-section="' + section + '"]');
    if (!vs || !vs.__rjSize || !missing(vs)) return false;
    e.preventDefault(); e.stopImmediatePropagation();
    sizeSets(vs).forEach(function (fs) { fs.classList.add('rj-size-error'); });
    var fs = sizeSets(vs).filter(function (f) { return !f.querySelector('input:checked'); })[0];
    if (fs) {
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = fs.querySelector('input:not(.is-disabled)') || fs.querySelector('input');
      if (first) first.focus({ preventScroll: true });
    }
    Array.prototype.forEach.call(document.querySelectorAll('.mobile-sticky-atc__button.loading'), function (b) { b.classList.remove('loading'); });
    return true;
  }
  document.addEventListener('submit', function (e) {
    /* getAttribute: the form holds an input named "id", which shadows form.id. */
    var f = e.target, fid = f && f.getAttribute ? f.getAttribute('id') || '' : '';
    if (fid.indexOf('product-form-') !== 0) return;
    block(fid.replace('product-form-', ''), e);
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.rj-size-wait');
    if (!b) return;
    var f = b.closest('form[id^="product-form-"]');
    var host = b.closest('mobile-sticky-atc');
    var id = f ? f.getAttribute('id') : (host ? host.dataset.targetForm : '');
    if (id) block(id.replace('product-form-', ''), e);
  }, true);
  /* R-D11: a ring-size filter on its own also lists rings whose chosen size is sold out (Search & Discovery matches the
     option value, not its stock). Combined with "In stock", Shopify filters at variant level, so choosing a size also
     ticks the theme's own In stock filter (visible, and the shopper can untick it). Runs before the theme's debounced
     submit, so both go in the same request. */
  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.matches || !box.checked || !box.matches('input[name="filter.v.option.size"]')) return;
    var form = box.closest('form'); if (!form) return;
    var stock = form.querySelector('input[name="filter.v.availability"][value="1"]');
    if (stock && !stock.checked && !stock.disabled) stock.checked = true;
  }, true);
  var css = document.createElement('style');
  css.textContent = '.rj-size-error{animation:rjShake .3s}.rj-size-error .form__label,.rj-size-error legend{color:#ca2027}' +
    '.rj-size-required .form__label__value{color:#ca2027;font-weight:600}' +
    '@keyframes rjShake{25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}@media (prefers-reduced-motion:reduce){.rj-size-error{animation:none}}';
  document.head.appendChild(css);
  function init() {
    scan(document);
    var drawer = document.getElementById('Product-Drawer');
    if (drawer && window.MutationObserver) new MutationObserver(function () { scan(drawer); }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () { scan(document); });
})();
